import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../constants/dataAids';
import renderModes from '../constants/renderModes';

const styles = {
  modalBackground: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'transparent',
    paddingHorizontal: 'small'
  },
  text: {
    marginBottom: '0',
    fontFamily: 'GD Sherpa, Arial, sans-serif',
    fontSize: '16px',
    lineHeight: '26px'
  }
};

const EmptyServiceListModal = ({ getStartedUrl, staticContent }) => {
  const {
    Element: { Block },
    Component: { ZeroStateOverlay }
  } = UX2;

  const openUrl = url => {
    window.location.href = url;
  };

  return (
    <Block style={ styles.modalBackground } data-aid={ dataAids.EMPTY_CONTAINER_RENDERED }>
      <ZeroStateOverlay
        renderMode={ renderModes.EDIT }
        beforeContent={ <p style={ styles.text }>{ staticContent.emptyServiceListTitle }</p> }
        button={{
          onClick: () => openUrl(getStartedUrl),
          children: staticContent.emptyServiceListCallToAction
        }}
      />
    </Block>
  );
};

EmptyServiceListModal.propTypes = {
  getStartedUrl: PropTypes.string,
  category: PropTypes.string,
  staticContent: PropTypes.object.isRequired
};

export default EmptyServiceListModal;
